import apiClient from "@/shared/api/apiClient";

export const getNotariesInfo = async (params) => {
  try {
    const { data } = await apiClient.get(
      "/notaries/info",
      {
        params,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("getNotariesInfo failed", e);
  }
};

export const getSchemeNotaries = async () => {
  try {
    const { data } = await apiClient.get("/notaries/info/schema");
    return data;
  } catch (e) {
    console.error("getSchemeNotaries failed", e);
  }
};

export const updateNotaryProfile = async (payload) => {
  const { data } = await apiClient.put("/notaries/", payload);
  return data;
};

export const createNotary = async (payload) => {
  const { data } = await apiClient.post("/notaries/", payload);
  return data;
};

export const getNotariesList = async (params) => {
  try {
    const { data } = await apiClient.get("/notaries/notaries-list", { params });
    return data;
  } catch (e) {
    console.error("getNotariesList failed", e);
  }
};

export const getNotaryItem = async (userUuid, { signal } = {}) => {
  try {
    const { data } = await apiClient.get(`/notaries/${userUuid}/`, { signal });
    return data;
  } catch (e) {
    if (e?.name === "CanceledError" || e?.code === "ERR_CANCELED") throw e;
    console.error("getNotaryItem failed", e);
  }
};

export const updateNotary = async (userUuid, payload) => {
  const { data } = await apiClient.put(`/notaries/${userUuid}`, payload);
  return data;
};

export const deleteNotary = async (userUuid) => {
  const { data } = await apiClient.delete(`/notaries/${userUuid}`);
  return data;
};

export const notaryHeartbeat = async () => {
  const { data } = await apiClient.post(
    "/notaries/heartbeat/",
    {},
    { metaData: { isNotificationDisabled: true } }
  );
  return data;
};
